module.exports = __webpack_public_path__ + "img/s-7.72855a77.png";